import { ComponentType, lazy, LazyExoticComponent, Suspense } from 'react';
import classnames from 'classnames';

import { useAppStore, type IAppStore } from '@/store';
import { Screen } from '@/types';
import useHomeLayoutExperiment from '@/hooks/useHomeLayoutExperiment';
import useStyles from './styles';

import Create from '@/components/Create';

const ContinuousGallery = lazy(() => import('@/components/ContinuousGallery'));
const CategoryRowsHome = lazy(() => import('@/components/CategoryRowsHome'));
const Loading = lazy(() => import('@/components/Loading'));
const Generations = lazy(() => import('@/components/Generations'));

const selector = (store: IAppStore) => ({ screen: store.screen });

const overlayComponents: Partial<
  Record<Screen, LazyExoticComponent<ComponentType> | ComponentType>
> = {
  [Screen.Create]: Create,
  [Screen.Loading]: Loading,
  [Screen.Files]: Generations,
};

const MobileLayout = () => {
  const { screen } = useAppStore(selector);
  const classes = useStyles();
  const { isCardRowLayout } = useHomeLayoutExperiment();

  const isLibrary = screen === Screen.Library;
  const Overlay = overlayComponents[screen];

  return (
    <div className={classes.mobileContent}>
      <div
        className={classnames(classes.screenLayer, {
          [classes.hiddenLayer]: !isLibrary,
        })}
        aria-hidden={!isLibrary}
      >
        <Suspense fallback={null}>
          {isCardRowLayout ? <CategoryRowsHome /> : <ContinuousGallery />}
        </Suspense>
      </div>

      {!isLibrary && Overlay && (
        <div className={classes.screenLayer}>
          <Suspense fallback={null}>
            <Overlay />
          </Suspense>
        </div>
      )}
    </div>
  );
};

export default MobileLayout;
